import { inView30 } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import * as React from 'react';
import S from './RichText.styles';
const RichText = ({ title = '', introContent = '', bgColor = '', content, alignment = 'left', width = 'default', styles, ...otherProps }) => {
    const [refContainer, inView] = useInView({ rootMargin: inView30 });
    return (React.createElement(S.Container, { ref: refContainer, "data-align": alignment, "data-bg": bgColor, "data-inview": inView, "data-width": width, ...otherProps },
        React.createElement(S.Inner, null,
            (title || content) && (React.createElement(S.IntroContent, null,
                title && (React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title)),
                introContent && (React.createElement(S.TopContent, { dangerouslySetInnerHTML: { __html: introContent } })))),
            React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content }, styles: styles }))));
};
export default RichText;
